import { apiCall, apiUpload } from '@/lib/api-client';
import type {
  BatchPreviewResponse,
  BatchUploadResponse,
  BatchListPage,
  BatchDetail,
  UploadMetadata,
} from '@/types/api';

export const batchesApi = {
  preview: (file: File) => {
    const fd = new FormData();
    fd.append('file', file);
    return apiUpload<BatchPreviewResponse>('/batches/preview', fd);
  },

  upload: (file: File, metadata: UploadMetadata) => {
    const fd = new FormData();
    fd.append('file', file);
    if (metadata.programName) fd.append('programName', metadata.programName);
    if (metadata.sourceDate) fd.append('sourceDate', metadata.sourceDate);
    if (metadata.notes) fd.append('notes', metadata.notes);
    return apiUpload<BatchUploadResponse>('/batches/upload', fd);
  },

  list: (limit = 25, offset = 0) =>
    apiCall<BatchListPage>(`/batches?limit=${limit}&offset=${offset}`),

  detail: (id: string) => apiCall<BatchDetail>(`/batches/${id}`),
};
